/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import 'assets/css/index.css';
import { getTheme } from '@totalsoft/rocket-ui';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loadApplicationTheme } from 'features/settings/dealerBranding/actionCreators';
import { camelize } from 'humps';
import userManager from 'utils/userManager';

const { REACT_APP_DEFAULT_THEME } = process.env;

const ThemeProvider = ({ actions, children, user, applicationThemeLoaded }) => {
  const [applicationTheme, setApplicationTheme] = useState({});

  useEffect(() => {
    userManager.signinSilent().catch(() => {
      userManager.signinRedirect({
        data: { redirectUrl: window.location.pathname }
      });
    });
  }, []);

  useEffect(() => {
    if (user && !user.expired && !applicationThemeLoaded) loadApplicationTheme();
  }, [user, applicationThemeLoaded]);

  const loadApplicationTheme = () => {
    actions.loadApplicationTheme().then(data => {
      setApplicationTheme(data);
    });
  };

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={getTheme({ globals: { theme: camelize(applicationTheme?.themeName || REACT_APP_DEFAULT_THEME || '') } })}>
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

ThemeProvider.propTypes = {
  actions: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
  user: PropTypes.object,
  applicationThemeLoaded: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.oidc?.user,
    applicationThemeLoaded: state.dealerBranding.theme.loaded
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadApplicationTheme
      },
      dispatch
    )
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(ThemeProvider);
